import { environment } from 'src/environments/environment';
import { UserRole } from '../shared/auth.roles';
const adminRoot = environment.adminRoot;

export interface IMenuItem {
  id?: string;
  icon?: string;
  label: string;
  to: string;
  newWindow?: boolean;
  subs?: IMenuItem[];
  roles?: UserRole[];
}

const data: IMenuItem[] = [
  {
    icon: 'iconsminds-home',
    label: 'Inicio',
    to: `${adminRoot}/vien/start`,
    roles: [UserRole.Admin, UserRole.User, UserRole.Report],
  },
  {
    icon: 'iconsminds-post-office',
    label: 'Empresas',
    to: `${adminRoot}/empresa`,
    roles: [UserRole.Admin],
  },
  {
    icon: 'iconsminds-clothing-store',
    label: 'Locales',
    to: `${adminRoot}/locales`,
    roles: [UserRole.User],
  },
  {
    icon: 'iconsminds-support',
    label: 'Soporte Técnico',
    to: `${adminRoot}/vien2`,
    roles: [UserRole.User, UserRole.Report],
    subs: [
      {
        icon: 'iconsminds-project',
        label: 'Historial de alertas',
        to: `${adminRoot}/soporte`,
        roles: [UserRole.User],
      },
      // {
      //   icon: 'iconsminds-save',
      //   label: 'Respaldos',
      //   to: `${adminRoot}/respaldos`,
      //   roles: [UserRole.User, UserRole.Report],
      // },
      // {
      //   icon: 'iconsminds-refresh',
      //   label: 'Migración',
      //   to: `${adminRoot}/migracion`,
      //   roles: [UserRole.User],
      // }
    ]
  },
  {
    icon: 'iconsminds-user',
    label: 'Usuarios',
    to: `${adminRoot}/registro`,
    roles: [UserRole.Admin, UserRole.User],
  },
  {
    icon: 'iconsminds-files',
    label: 'Reportes',
    to: `${adminRoot}/vien`,
    roles: [UserRole.User, UserRole.Report],
    subs: [
          // {
          //   icon: 'iconsminds-project',
          //   label: 'Reporte general',
          //   to: `${adminRoot}/reportes/historico`,
          //   roles: [UserRole.User, UserRole.Report],
          // },
          {
            icon: 'iconsminds-project',
            label: 'Reporte general',
            to: `${adminRoot}/reportes/promedios`,
            roles: [UserRole.User, UserRole.Report],
          },
          {
            icon: 'iconsminds-tag-3',
            label: 'Reporte por día',
            to: `${adminRoot}/reportes/promedio-horas`,
            roles: [UserRole.User, UserRole.Report],
          },
        ],
  }
];
export default data;
